export default __webpack_public_path__ + "static/media/sns.6a8f286a.csv";